import { useEffect } from 'react'
import HomePage from '@/app/page'
import AboutPage from '@/app/about/page'
import BeginnersGuidePage from '@/app/beginners-guide/page'
import CommunityPage from '@/app/community/page'
import DevelopersPage from '@/app/developers/page'
import DocsPage from '@/app/docs/page'
import FaqPage from '@/app/faq/page'
import SupportPage from '@/app/support/page'
import RegisterPage from '@/app/register/page'
import LoginPage from '@/app/login/page'
import AccountPage from '@/app/account/page'
import ForumPage from '@/app/forum/page'
import ForumGalleryPage from '@/app/forum/gallery/page'
import NewTopicPage from '@/app/forum/new/page'
import ForumTopicPage from '@/app/forum/topic/[id]/page'
import FilesPage from '@/app/files/page'
import PrivacyPage from '@/app/privacy/page'
import AdminPage from '@/app/admin/page'
import DonatePage from '@/app/donate/page'
import ProgrammerPage from '@/app/programmer/page'

const routes: Record<string, { title: string; page: () => React.JSX.Element | null }> = {
  '/': { title: 'NewChirp — Modern Radio Programming', page: HomePage },
  '/about': { title: 'About — NewChirp', page: AboutPage },
  '/beginners-guide': { title: 'Beginners Guide — NewChirp', page: BeginnersGuidePage },
  '/community': { title: 'Community — NewChirp', page: CommunityPage },
  '/developers': { title: 'Developers — NewChirp', page: DevelopersPage },
  '/docs': { title: 'Documentation — NewChirp', page: DocsPage },
  '/faq': { title: 'FAQ — NewChirp', page: FaqPage },
  '/support': { title: 'Support — NewChirp', page: SupportPage },
  '/programmer': { title: 'Web Programmer Beta — NewChirp', page: ProgrammerPage },
  '/donate': { title: 'Donate — NewChirp', page: DonatePage },
  '/register': { title: 'Create Account — NewChirp', page: RegisterPage },
  '/login': { title: 'Log in — NewChirp', page: LoginPage },
  '/account': { title: 'Your Account — NewChirp', page: AccountPage },
  '/forum': { title: 'Community Forums — NewChirp', page: ForumPage },
  '/forum/gallery': { title: 'Community Gallery — NewChirp Forums', page: ForumGalleryPage },
  '/forum/new': { title: 'New Topic — NewChirp Forums', page: NewTopicPage },
  '/files': { title: 'Upload and Share Files — NewChirp Forums', page: FilesPage },
  '/privacy': { title: 'Privacy Policy — NewChirp', page: PrivacyPage },
  '/admin': { title: 'Admin — NewChirp', page: AdminPage },
}

export default function App() {
  const pathname = window.location.pathname.replace(/\/$/, '') || '/'
  const forumTopicMatch = pathname.match(/^\/forum\/topic\/(\d+)$/)
  const route =
    routes[pathname] ??
    (forumTopicMatch ? { title: 'Topic — NewChirp Forums', page: ForumTopicPage } : null) ??
    routes['/']
  const Page = route.page

  useEffect(() => {
    document.title = route.title
    if (window.location.hash) {
      requestAnimationFrame(() => document.querySelector(window.location.hash)?.scrollIntoView())
    }
  }, [route.title])

  return <Page />
}
